export default __webpack_public_path__ + "static/media/calender-round.f22c00b3.svg";